// extracted by mini-css-extract-plugin
module.exports = {"promoTag":"styles_promoTag__ogP9q","labelWrapper":"styles_labelWrapper__z1xVe"};